import React from "react";
import Typewriter from "typewriter-effect";

function Type() {
  return (
    <Typewriter
      options={{
        strings: [
          "Mechatronics Software Engineer @ Franka Robotics",
          "MSc - Robotics Cognition Intelligence",
          "BE - Mechanical Engineer",
          "Developer",
          "Open Source Contributor",
        ],
        autoStart: true,
        loop: true,
        deleteSpeed: 50,
      }}
    />
  );
}

export default Type;
